/* src/app/pages/login-v2/pages/auth-shell.page.scss */
:host {
  display: block;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  --auth-card-width-mobile: 100%;
  --auth-card-width-desktop: 558px;
  --auth-card-radius: 12px;
  --auth-page-bg: var(--secondary-subtle-default);
  --auth-card-bg: var(--contrast-inverse);
}
.auth-page {
  min-height: 100%;
  background: var(--auth-page-bg);
}
.auth-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%;
  box-sizing: border-box;
  padding: 80px 0;
  gap: 12px;
}
@media (max-width: 1099px) {
  .auth-main {
    padding: 16px 0;
  }
}
.auth-brand {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.auth-brand .auth-brand__logo {
  width: 240px;
}
.auth-form-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  max-width: var(--auth-card-width-desktop);
  box-sizing: border-box;
}
@media (max-width: 1099px) {
  .auth-form-wrap {
    max-width: var(--auth-card-width-mobile);
    padding: 0 16px;
  }
}
:host ::ng-deep router-outlet + * {
  display: block;
  width: 100%;
}
:host ::ng-deep .auth-submit.p-button {
  width: 100%;
}
/*# sourceMappingURL=auth-shell.page.css.map */
